export const GET_MILESTONES = 'GET_MILESTONES';
export const UPDATE_MILESTONES = 'UPDATE_MILESTONES';
export const CANCEL_ENTITY = 'CANCEL_ENTITY';
export const GET_MILESTONES_STATISTICS = 'GET_MILESTONES_STATISTICS';
export const UPDATE_MILESTONE_DATE = 'UPDATE_MILESTONE_DATE';
export const SET_BOUNDARY_INDEX = 'SET_BOUNDARY_INDEX';
export const GET_BOUNDARY = 'GET_BOUNDARY';